var _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2873_997",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4.60393,
    width: 21,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 4.60393,
    width: 21,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4605 11.7373C16.5298 11.435 16.5664 11.1202 16.5664 10.7969C16.5664 8.48117 14.6892 6.60393 12.3735 6.60393C10.5207 6.60393 8.94854 7.80573 8.39409 9.47233C7.99061 9.0937 7.4478 8.86181 6.85082 8.86181C5.605 8.86181 4.59506 9.87175 4.59506 11.1176C4.59506 11.3328 4.62522 11.5411 4.68154 11.7383C3.18751 11.8159 2 13.0519 2 14.5652C2 16.1287 3.26741 17.3961 4.83083 17.3961H16.3308C17.8942 17.3961 19.1616 16.1287 19.1616 14.5652C19.1616 13.0453 17.9637 11.8051 16.4605 11.7373Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4605 11.7373L14.9984 11.4023L14.5968 13.1548L16.3929 13.2358L16.4605 11.7373ZM8.39409 9.47233L7.36766 10.5661L9.0773 12.1705L9.81739 9.94583L8.39409 9.47233ZM4.68154 11.7383L4.75937 13.2363L6.64141 13.1385L6.12387 11.3264L4.68154 11.7383ZM17.9226 12.0724C18.0169 11.6609 18.0664 11.2337 18.0664 10.7969H15.0664C15.0664 11.0067 15.0427 11.2091 14.9984 11.4023L17.9226 12.0724ZM18.0664 10.7969C18.0664 7.65274 15.5176 5.10393 12.3735 5.10393V8.10393C13.8608 8.10393 15.0664 9.30959 15.0664 10.7969H18.0664ZM12.3735 5.10393C9.85552 5.10393 7.72303 6.73768 6.97079 8.99882L9.81739 9.94583C10.174 8.87377 11.1858 8.10393 12.3735 8.10393V5.10393ZM9.42052 8.37851C8.75002 7.74932 7.84403 7.36181 6.85082 7.36181V10.3618C7.05156 10.3618 7.23119 10.4381 7.36766 10.5661L9.42052 8.37851ZM6.85082 7.36181C4.77657 7.36181 3.09506 9.04332 3.09506 11.1176H6.09506C6.09506 10.7002 6.43343 10.3618 6.85082 10.3618V7.36181ZM3.09506 11.1176C3.09506 11.4736 3.14501 11.8204 3.23921 12.1502L6.12387 11.3264C6.10543 11.2618 6.09506 11.1921 6.09506 11.1176H3.09506ZM3.5 14.5652C3.5 13.8543 4.05827 13.2727 4.75937 13.2363L4.6037 10.2403C2.31676 10.3591 0.5 12.2495 0.5 14.5652H3.5ZM4.83083 15.8961C4.09583 15.8961 3.5 15.3002 3.5 14.5652H0.5C0.5 16.9571 2.43898 18.8961 4.83083 18.8961V15.8961ZM16.3308 15.8961H4.83083V18.8961H16.3308V15.8961ZM17.6616 14.5652C17.6616 15.3002 17.0658 15.8961 16.3308 15.8961V18.8961C18.7226 18.8961 20.6616 16.9571 20.6616 14.5652H17.6616ZM16.3929 13.2358C17.0985 13.2676 17.6616 13.8511 17.6616 14.5652H20.6616C20.6616 12.2395 18.829 10.3427 16.5281 10.2389L16.3929 13.2358Z",
    fill: "#576473",
    mask: "url(#path-1-outside-1_2873_997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53097 15.1918C8.2313 15.4215 7.85663 15.558 7.4503 15.558C6.46841 15.558 5.67126 14.7609 5.67126 13.779C5.67126 12.7971 6.46841 12 7.4503 12C7.85663 12 8.2313 12.1365 8.53097 12.3661",
    stroke: "#576473",
    strokeWidth: 1.2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3752 15.5581C12.3578 15.5581 13.1543 14.7616 13.1543 13.779C13.1543 12.7965 12.3578 12 11.3752 12C10.3927 12 9.59619 12.7965 9.59619 13.779C9.59619 14.7616 10.3927 15.5581 11.3752 15.5581Z",
    stroke: "#576473",
    strokeWidth: 1.2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3954 13.8177C14.6629 13.3827 15.1978 13.3827 15.4653 13.6002C15.7328 13.8177 15.7328 14.2528 15.4653 14.6879C15.278 15.0142 14.7966 15.3404 14.3954 15.558H15.6659",
    stroke: "#576473",
    strokeWidth: 0.8,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmissions);
export default __webpack_public_path__ + "static/media/emissions.465d6199f370dd3d0df9aa2898cf5253.svg";
export { ForwardRef as ReactComponent };